(() => {
  const dataEl = document.querySelector('script[id^="alpha-dv2-data-"]');
  if (!dataEl) return;

  let data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function plainText(value) {
    const el = document.createElement('div');
    el.innerHTML = String(value || '');
    return (el.textContent || el.innerText || '').trim();
  }

  // Normalize products: handle 3 shapes
  //   1. Liquid initial: {image: "url", price: "599,00 €", url: "..."}
  //   2. Liquid image object (rare): {image: {src: "..."}}
  //   3. Shopify API /products.json: {images: [{src:"..."}], variants: [{price:"599.00"}], handle: "..."}
  function normalize(p) {
    let imageUrl = '';
    if (typeof p.image === 'string') imageUrl = p.image;
    else if (p.image && typeof p.image === 'object' && p.image.src) imageUrl = p.image.src;
    else if (Array.isArray(p.images) && p.images[0] && p.images[0].src) imageUrl = p.images[0].src;

    let price = plainText(p.price || '');
    if (!price && Array.isArray(p.variants) && p.variants[0] && p.variants[0].price) {
      const cents = parseFloat(p.variants[0].price);
      if (!isNaN(cents)) {
        price = cents.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
      } else {
        price = p.variants[0].price + ' €';
      }
    }

    let url = p.url || '';
    if (!url && p.handle) url = '/products/' + p.handle;

    let srcset = '';
    if (imageUrl) {
      const sep = imageUrl.includes('?') ? '&' : '?';
      const swap = (w) => imageUrl.includes('width=') ? imageUrl.replace(/width=\d+/, 'width=' + w) : imageUrl + sep + 'width=' + w;
      srcset = `${swap(400)} 400w, ${swap(800)} 800w, ${swap(1200)} 1200w, ${swap(1600)} 1600w`;
    }
    return {
      title: p.title || '',
      vendor: p.vendor || '',
      price: price,
      url: url || '#',
      image: imageUrl,
      image_srcset: srcset,
      image_sizes: '(max-width: 800px) 96vw, (max-width: 1200px) 64vw, 1000px',
      image_alt: p.title || ''
    };
  }

  let allProducts = (data.products || []).map(normalize);
  const totalInCollection = data.total || allProducts.length;
  const collectionHandle = data.collection_handle || '';
  const PAGE_SIZE = 50;
  let nextPage = 2;
  let loading = false;
  let noMore = allProducts.length >= totalInCollection;

  const modal = document.querySelector('[data-alpha-dv2-modal]');
  const openBtn = document.querySelector('[data-alpha-dv2-open]');
  const closeBtn = document.querySelector('[data-alpha-dv2-close]');
  const prevBtn = document.querySelector('[data-alpha-dv2-prev]');
  const nextBtn = document.querySelector('[data-alpha-dv2-next]');
  const viewport = document.querySelector('[data-alpha-dv2-viewport]');
  const counter = document.querySelector('[data-alpha-dv2-counter]');
  const statusEl = document.querySelector('[data-alpha-dv2-status]');
  const vendor = document.querySelector('[data-alpha-dv2-vendor]');
  const title = document.querySelector('[data-alpha-dv2-title]');
  const price = document.querySelector('[data-alpha-dv2-price]');
  const link = document.querySelector('[data-alpha-dv2-link]');

  if (!modal || !openBtn || !viewport) return;

  let index = 0;
  const preloadCache = new Set();

  function preloadImage(p) {
    if (!p || !p.image || preloadCache.has(p.image)) return;
    preloadCache.add(p.image);
    const img = new Image();
    if (p.image_srcset) img.srcset = p.image_srcset;
    if (p.image_sizes) img.sizes = p.image_sizes;
    img.src = p.image;
  }

  function preloadAround(i) {
    preloadImage(allProducts[i + 1]);
    preloadImage(allProducts[i - 1]);
  }

  function show(i) {
    if (!allProducts.length) return;
    index = ((i % allProducts.length) + allProducts.length) % allProducts.length;
    const p = allProducts[index];
    viewport.innerHTML = '';
    const img = document.createElement('img');
    img.src = p.image || '';
    if (p.image_srcset) img.srcset = p.image_srcset;
    if (p.image_sizes) img.sizes = p.image_sizes;
    img.alt = p.image_alt || p.title || '';
    img.decoding = 'async';
    img.loading = index === 0 ? 'eager' : 'lazy';
    viewport.appendChild(img);
    if (counter) counter.textContent = (index + 1) + ' / ' + totalInCollection;
    if (vendor) vendor.textContent = p.vendor || '';
    if (title) title.textContent = p.title || '';
    if (price) price.textContent = p.price || '';
    if (link) { link.href = p.url || '#'; link.textContent = 'Voir le produit'; }
    preloadAround(index);
    // Trigger lazy load when approaching end
    if (!noMore && index >= allProducts.length - 8) {
      loadMore();
    }
  }

  async function loadMore() {
    if (loading || noMore || !collectionHandle) return;
    loading = true;
    if (statusEl) { statusEl.hidden = false; statusEl.textContent = 'Chargement…'; }
    try {
      const url = `/collections/${collectionHandle}/products.json?limit=${PAGE_SIZE}&page=${nextPage}`;
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const j = await res.json();
      const incoming = (j.products || []).map(normalize);
      if (incoming.length === 0) {
        noMore = true;
      } else {
        allProducts = allProducts.concat(incoming);
        nextPage++;
        if (allProducts.length >= totalInCollection) noMore = true;
        if (allProducts.length - index <= 4) preloadAround(index);
      }
      if (statusEl) statusEl.textContent = allProducts.length + ' / ' + totalInCollection + ' œuvres chargées';
    } catch (e) {
      if (statusEl) statusEl.textContent = 'Erreur de chargement';
    } finally {
      loading = false;
    }
  }

  function open() {
    show(0);
    modal.hidden = false;
    document.body.classList.add('alpha-dv2-open');
  }
  function close() {
    modal.hidden = true;
    document.body.classList.remove('alpha-dv2-open');
  }

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (prevBtn) prevBtn.addEventListener('click', () => show(index - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => show(index + 1));

  document.addEventListener('keydown', (e) => {
    if (modal.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(index - 1);
    else if (e.key === 'ArrowRight') show(index + 1);
  });

  let startX = 0;
  viewport.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
  viewport.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
  }, { passive: true });

  viewport.addEventListener('click', (e) => {
    const rect = viewport.getBoundingClientRect();
    const x = e.clientX - rect.left;
    if (x < rect.width / 3) show(index - 1);
    else if (x > rect.width * 2 / 3) show(index + 1);
  });

  if (statusEl) statusEl.textContent = allProducts.length + ' / ' + totalInCollection + ' œuvres';
})();
